/**
 * Date oficiale Operator e-Tesa - sursă unică de adevăr.
 * Folosit în footer, paginile legale, facturi proforma platforma, audit GDPR.
 *
 * IMPORTANT: dacă datele firmei se schimbă (ex: schimbare sediu), actualizează DOAR aici.
 */
export const ETESA_OPERATOR = {
  legal_name: "TEHNIC SMART CON S.R.L.",
  short_name: "Tehnic Smart Con",
  brand: "e-Tesa",
  cui: "44303561",
  reg_com: "J22/1696/2021",
  euid: "ROONRC.J2021001696225",
  founded_at: "20.05.2021",
  address_county: "Iași",
  address_city: "Iași",
  address_street: "Bdul. Socola Nr. 4, Bl. C4, Sc. C, Et. 4",
  address_zip: "700194",
  address_full:
    "Bdul. Socola Nr. 4, Bl. C4, Sc. C, Et. 4, Cod 700194, Iași, jud. Iași",
  email: "tehnic.smart.con@gmail.com",
  support_email: "tehnic.smart.con@gmail.com",
  dpo_email: "tehnic.smart.con@gmail.com",
  phone: "0755 898 253",
  website: "https://e-tesa.ro",
  anpc_sol_url: "https://ec.europa.eu/consumers/odr",
  anpc_url: "https://anpc.ro",
  anspdcp_url: "https://www.dataprotection.ro",
};
